import { html } from "lit-html";
import { LocalizedPage, PageValue } from "./AdminPageViewModel";
import { submitPagePost } from "./adminCommon";
import { useAjax } from "Services/useAjax";
import classNames from "classnames";

export interface Props {
	isPreview: boolean;
	pagesValues: PageValue[];
}

export const usePagesSection = (props: Props) => {
	const { ajaxRequest } = useAjax();

	const invalidate = async (e: MouseEvent, pageAlias: string) => {
		e.preventDefault();
		e.stopPropagation();
		await submitPagePost(pageAlias, ajaxRequest);
	};

	const buttonTemplate = (pageAlias: string) => {
		const handleInvalidate = (e: MouseEvent) => invalidate(e, pageAlias);

		return html`
		<button
			type="submit"
			class="mt-5 inline-flex h-[30px] items-center justify-center rounded-lg border-0 bg-n-blue px-[15px] tracking-normal text-white hover:bg-n-red hover:text-white disabled:hover:bg-n-blue"
			value="Invalidate"
			@click=${handleInvalidate}
		>
			Invalidate
		</button>
	`;
	};

	const localizedPageTemplate = (localizedPage: LocalizedPage) => {
		const validityIconTemplate = localizedPage.IsValid ? html`✔` : html`✘`;
		const errorMessageTemplate = !localizedPage.IsValid
			? html`<label class="text-[#db0000]">Message: ${localizedPage.LastRefreshMessage}</label>`
			: "";

		return html`
		<li
			class=${classNames("flex flex-col gap-2", {
				"text-[#db0000]": !localizedPage.IsValid,
				"text-[#83b245]": localizedPage.IsValid,
			})}
		>
			<span>
				<span> ${localizedPage.Locale} </span>
				<span> ${validityIconTemplate} </span>
			</span>
			${errorMessageTemplate}
		</li>
	`;
	};

	const pageTemplate = (page: PageValue) => html`
		<div class="relative">
			<label
				class="relative mb-1 inline-block border-b border-solid border-n-blue bg-n-dark-gray py-1.5 pl-3 pr-8 text-base"
				>${page.Alias}</label
			>
			<ul class="list-none">
				<li><span>Expires On:</span><br />${page.ExpiresOn}</li>
				<li><span>Refreshed On:</span><br />${page.RefreshedOn}</li>
			</ul>
			${buttonTemplate(page.Alias)}
			<div class="mx-0 mb-[25px] mt-[10px]">
				<ul>
					${page.LocalizedPages.map(localizedPageTemplate)}
				</ul>
			</div>
		</div>
	`;

	const contentTemplate = () => !props.isPreview
		? html`<div class="mt-4 grid grid-cols-3 gap-4">${props.pagesValues.map(pageTemplate)}</div>`
		: html`<div class="w-full"><label class="preview-label">In Preview</label></div>`;

	const htmlTemplate = () => html`
		<section>
			${contentTemplate()}
		</section>
	`;

	return { htmlTemplate };
};
